import { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Terms() {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/pages/terms`)
      .then(res => setContent(res.data.content || ''))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-slate-50" data-testid="terms-page">
      <Navbar />
      <div className="pt-24 pb-12 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl font-serif font-bold tracking-tight text-slate-900 mb-12">Terms of Use</h1>
          {loading ? (
            <div className="flex justify-center py-12"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-slate-900"></div></div>
          ) : content ? (
            <div className="prose prose-slate max-w-none bg-white p-8 rounded border border-slate-200" data-testid="terms-content" dangerouslySetInnerHTML={{ __html: content }} />
          ) : (
            <p className="text-slate-500">Content coming soon.</p>
          )}
        </div>
      </div>
    </div>
  );
}
